/** Non-secret notices keep open tabs aligned with the shared browser cookie. */

export type BrowserSessionMutation = 'changed' | 'ended';

const CHANNEL_NAME = 'soundops-browser-session-events';
let channel: BroadcastChannel | null = null;

const browserSessionChannel = (): BroadcastChannel => {
  if (typeof BroadcastChannel === 'undefined') {
    throw new Error('Browser sessions require BroadcastChannel support.');
  }
  channel ??= new BroadcastChannel(CHANNEL_NAME);
  return channel;
};

export const publishBrowserSessionMutation = (mutation: BrowserSessionMutation): void => {
  browserSessionChannel().postMessage(mutation);
};

export const subscribeBrowserSessionMutations = (
  onMutation: (mutation: BrowserSessionMutation) => void,
): (() => void) => {
  const sessionChannel = browserSessionChannel();
  const listener = (event: MessageEvent<unknown>) => {
    if (event.data === 'changed' || event.data === 'ended') {
      onMutation(event.data);
    }
  };
  sessionChannel.addEventListener('message', listener);
  return () => sessionChannel.removeEventListener('message', listener);
};
